document.querySelectorAll("[data-accordion-trigger]").forEach((button) => {
  button.addEventListener("click", () => {
    const panel = document.getElementById(button.getAttribute("aria-controls"));
    const expanded = button.getAttribute("aria-expanded") === "true";
    button.setAttribute("aria-expanded", String(!expanded));
    panel.hidden = expanded;
  });
});

document.querySelectorAll("[data-tabs]").forEach((tabSet) => {
  const buttons = tabSet.querySelectorAll("[role='tab']");
  const panels = tabSet.querySelectorAll("[role='tabpanel']");

  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      const target = button.getAttribute("aria-controls");

      buttons.forEach((item) => {
        item.setAttribute("aria-selected", String(item === button));
        item.tabIndex = item === button ? 0 : -1;
      });

      panels.forEach((panel) => {
        panel.hidden = panel.id !== target;
      });
    });
  });
});

if ("IntersectionObserver" in window) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );

  document.querySelectorAll("[data-reveal]").forEach((item) => observer.observe(item));
} else {
  document.querySelectorAll("[data-reveal]").forEach((item) => item.classList.add("is-visible"));
}

/* ── Shop image carousel ── */
document.querySelectorAll("[data-shop-carousel]").forEach((carousel) => {
  const track = carousel.querySelector("[data-shop-track]");
  const dots  = carousel.querySelectorAll("[data-dot]");
  let current = 0;
  let timer;

  function goTo(index) {
    current = (index + dots.length) % dots.length;
    track.style.transform = `translateX(-${current * 100}%)`;
    dots.forEach((d, i) => {
      d.classList.toggle("is-active", i === current);
      d.setAttribute("aria-selected", String(i === current));
    });
  }

  function next() { goTo(current + 1); }

  function startAuto() { timer = setInterval(next, 4000); }
  function stopAuto()  { clearInterval(timer); }

  dots.forEach((dot) => {
    dot.addEventListener("click", () => {
      stopAuto();
      goTo(Number(dot.dataset.dot));
      startAuto();
    });
  });

  carousel.addEventListener("mouseenter", stopAuto);
  carousel.addEventListener("mouseleave", startAuto);
  carousel.addEventListener("focusin",    stopAuto);
  carousel.addEventListener("focusout",   startAuto);

  startAuto();
});
